module.exports = __webpack_public_path__ + "static/img/176_TO8_2012_og.7d93b2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/176_TO8_2012_og.jpg
// module id = 0am1
// module chunks = 0